define('responsive-gameday-tracking/src/js/GamedayTracking',['require','exports','module','es6ish-class/es6ish-class','./lib/switchboard'],function (require, module, exports) {

    var es6ishClass = require('es6ish-class/es6ish-class');

    var GamedayTracking = es6ishClass(function(selectorString) {

        // Set where on the page this is going on Scoreboard instance creation
        this.targetDivSelector = selectorString;
        
    });

    GamedayTracking.define({
        /**
         * Where are we placing this component?
         */
        targetDivSelector: ""
        // This is dumb
    }).define(require('./lib/switchboard'));
 
    return new GamedayTracking();
});
